import type { ReactNode } from 'react'

export interface EmptyStateProps {
  icon?: ReactNode
  title: string
  message?: string
  action?: ReactNode
}

/** Centered empty/placeholder state: icon + title + message + optional CTA. */
export function EmptyState({ icon, title, message, action }: EmptyStateProps) {
  return (
    <div className="flex min-h-[240px] flex-col items-center justify-center gap-3 p-10 text-center">
      {icon && <div className="text-text-muted">{icon}</div>}
      <div className="text-base font-semibold text-text-primary">{title}</div>
      {message && <p className="max-w-md text-sm text-text-secondary">{message}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  )
}
